<div class="dsg-save-as-dialog">
  <header class="dsg-save-as-head">
    <span class="dsg-save-as-icon"><mat-icon>save_as</mat-icon></span>
    <div>
      <h2 mat-dialog-title>Save dashboard as</h2>
      <p>Create a new dashboard while keeping the original unchanged.</p>
    </div>
  </header>

  <mat-dialog-content>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>New dashboard name</mat-label>
      <input
        matInput
        cdkFocusInitial
        [(ngModel)]="name"
        (focus)="selectText($event)"
        (input)="error = ''"
        (keyup.enter)="save()"
        aria-label="New dashboard name"
      />
      <mat-hint>The new dashboard will be saved as a separate copy.</mat-hint>
      <mat-error *ngIf="error">{{ error }}</mat-error>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-flat-button type="button" class="dsg-save-as-submit" (click)="save()">
      <mat-icon>content_copy</mat-icon>
      Save copy
    </button>
  </mat-dialog-actions>
</div>
